import * as moment from 'moment';

export const DEFAULT_PAYMENT_TERMS: number = 14;

export const isDateStringValid = (dateStr: string): boolean => {
  // Date should be in format 2019-01-08T10:27:29.000Z
  return Boolean(dateStr) && Boolean(dateStr.match(/^[0-9]{4}-[0-9]{1,2}/g));
};

export const updateHMS = (dateStr: string): string => {
  const { years, months, date } = moment(dateStr).toObject();
  const dateNew = moment().set({ years, months, date });
  return dateNew.toISOString();
};

export function calculateDaysFromStartDate(startDate: moment.Moment, days: number = DEFAULT_PAYMENT_TERMS): moment.Moment {
  if (isNaN(days)) {
    days = DEFAULT_PAYMENT_TERMS;
  }
  return startDate.clone().add(days, 'days');
}

export function formatDateByLocale(date: string, locale: string): string {
  const momentDate = moment(date).locale(locale.substr(3));
  return momentDate.format('L').toLocaleString();
}

export function formatDate(date: string | Date, format: string, language?: string): string {
  const momentDate = moment(date);
  if (language) {
    momentDate.locale(language);
  }
  return momentDate.format(format);
}

/**
 * Converts legacy date formats (d.m.Y,d/m/Y,Y-n-e,d M Y) for DatePicker
 * @param {string} format
 * @returns {string}
 */
export function transformDateFormatForMoment(format: string): string {
  switch (format) {
    case 'd.m.Y': return 'dd.M.Y';
    case 'd/m/Y': return 'dd/MM/Y';
    case 'Y-n-e': return 'Y-MM-dd';
    case 'd M Y': return 'D MMM Y';
    case 'h:i': return 'H:mm';
    case 'h.i': return 'H.mm';
    case 'H:i p': return 'h:mm a';
    case 'p H:i': return 'a h:mm';
    default: return format; // so that this works if/when the format is fixed one day
  }
}

export function transformDateTimeFormat(dateFormat: string, timeFormat: string): string {
  return `${transformDateFormatForMoment(dateFormat)} ${transformDateFormatForMoment(timeFormat)}`;
}
